import React, { useEffect } from 'react';
import './debug.css';

const Debug = () => {
  useEffect(() => {
    document.body.classList.add('debug');
  }, []);

  return <></>
};

export default Debug;